import React, { useEffect, useState } from 'react';
import ShowcaseSidebar from './showcase-sidebar';
import Showcase from './showcase';
import { Layout, Spin } from 'antd';
import ShowcaseSuggestions from './showcase-suggestions';
import { useIsMobile } from '../hooks/screen-size';
import { getBotsAsync } from '../store/bot-slice';
import { useDispatch, useSelector } from 'react-redux';
// import BottomNavBar from './bottom-nav-bar';
const { Content } = Layout;

function ShowcaseLayout() {
  const isMobile = useIsMobile();
  const [questionText, setQuestionText] = useState('');
  const { loading } = useSelector((state) => state.bots);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBotsAsync());
  }, []);

  return (
    <>
      {loading ? (
        <div
          size="large"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
          }}
        >
          <Spin spinning={true} />
        </div>
      ) : (
        <Layout style={{ height: '100vh' }}>
          {!isMobile && <ShowcaseSidebar />}
          <Layout>
            <Content>
              <Showcase
                questionText={questionText}
                setQuestionText={setQuestionText}
              />
            </Content>
          </Layout>
          {!isMobile && (
            <ShowcaseSuggestions setQuestionText={setQuestionText} />
          )}
        </Layout>
      )}
    </>
  );
}

export default ShowcaseLayout;
